import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";

const resource = `${Config.basePath}/traindata`;
// const proxyResource = `${Config.proxyPath}/traindata`;

export default {
  create(payload) {
    const text = payload.messages.split("\n");
    for (let i = 0; i < text.length; i++) {
      if (text[i][0] == "-") {
        text[i] = text[i].substring(1).trim();
      }
    }
    return Client.post(
      `${resource}/train`,
      { text, lang: payload.language },
      { headers: { "Content-Type": "application/json" } }
    );
  },
  list(payload) {
    return Client.get(`${resource}/list`, {
      params: payload,
    });
  },
  retrain(payload) {
    return Client.put(`${resource}/${payload}`);
  },
  options() {
    return Client.get(`${resource}/language`);
  },
  remove(id) {
    return Client.delete(`${resource}/story/${id}`);
  },
  update(id, payload) {
    const text = payload.messages.split("\n");
    for (let i = 0; i < text.length; i++) {
      if (text[i][0] == "-") {
        text[i] = text[i].substring(1).trim();
      }
    }

    return Client.put(`${resource}/story/${id}`, { text });
  },
  show(id) {
    return Client.get(`${resource}/story/${id}`);
  },
  retrains(payload) {
    return Client.post(`${resource}/retrain`, { lang: payload.language });
  },
};
